// extracted by mini-css-extract-plugin
var _1 = "Resizable_delimeter__32ae4";
var _2 = "Resizable_move__bf886";
var _3 = "Resizable_resizer__42523";
export { _1 as "delimeter", _2 as "move", _3 as "resizer" }
